import React, { useState } from 'react';
import { SearchIcon, FilterIcon, DownloadIcon, EyeIcon, CheckCircleIcon, XCircleIcon, TruckIcon, AlertCircleIcon, ClockIcon } from 'lucide-react';
export const OrdersManagement = () => {
  const [selectedStatus, setSelectedStatus] = useState<string>('all');
  // Sample data for orders
  const orders = [{
    id: 'ORD-12345',
    customer: 'John Smith',
    dealer: 'TechHub Singapore',
    date: '2023-05-15 14:30:22',
    amount: '$234.50',
    status: 'Completed',
    items: 3,
    paymentMethod: 'Credit Card'
  }, {
    id: 'ORD-12344',
    customer: 'Sarah Johnson',
    dealer: 'Mobile Masters',
    date: '2023-05-15 12:15:45',
    amount: '$129.99',
    status: 'Processing',
    items: 1,
    paymentMethod: 'PayPal'
  }, {
    id: 'ORD-12343',
    customer: 'Michael Brown',
    dealer: 'TechHub Singapore',
    date: '2023-05-14 09:22:10',
    amount: '$89.00',
    status: 'Completed',
    items: 2,
    paymentMethod: 'Credit Card'
  }, {
    id: 'ORD-12342',
    customer: 'Emma Wilson',
    dealer: 'Gadget World',
    date: '2023-05-14 18:05:33',
    amount: '$345.75',
    status: 'Shipped',
    items: 4,
    paymentMethod: 'Credit Card'
  }, {
    id: 'ORD-12341',
    customer: 'David Lee',
    dealer: 'Phone Paradise',
    date: '2023-05-13 11:45:20',
    amount: '$78.50',
    status: 'Completed',
    items: 1,
    paymentMethod: 'Google Pay'
  }, {
    id: 'ORD-12340',
    customer: 'Jennifer Taylor',
    dealer: 'Digital Dreams',
    date: '2023-05-13 10:30:15',
    amount: '$199.99',
    status: 'Cancelled',
    items: 2,
    paymentMethod: 'Credit Card'
  }, {
    id: 'ORD-12339',
    customer: 'Robert Johnson',
    dealer: 'TechHub Singapore',
    date: '2023-05-12 14:22:45',
    amount: '$499.00',
    status: 'Pending',
    items: 1,
    paymentMethod: 'Bank Transfer'
  }, {
    id: 'ORD-12338',
    customer: 'Lisa Anderson',
    dealer: 'Mobile Masters',
    date: '2023-05-12 09:15:30',
    amount: '$149.50',
    status: 'Shipped',
    items: 3,
    paymentMethod: 'PayPal'
  }, {
    id: 'ORD-12337',
    customer: 'Kevin Martin',
    dealer: 'Gadget World',
    date: '2023-05-11 16:40:12',
    amount: '$299.99',
    status: 'Refunded',
    items: 2,
    paymentMethod: 'Credit Card'
  }, {
    id: 'ORD-12336',
    customer: 'Patricia White',
    dealer: 'TechHub Singapore',
    date: '2023-05-11 13:25:40',
    amount: '$599.00',
    status: 'Completed',
    items: 1,
    paymentMethod: 'Credit Card'
  }];
  const filteredOrders = selectedStatus === 'all' ? orders : orders.filter(order => order.status.toLowerCase() === selectedStatus.toLowerCase());
  const getStatusIcon = (status: string) => {
    switch (status.toLowerCase()) {
      case 'completed':
        return <CheckCircleIcon className="h-5 w-5 text-green-500" data-id="element-1656" />;
      case 'processing':
        return <ClockIcon className="h-5 w-5 text-yellow-500" data-id="element-1657" />;
      case 'shipped':
        return <TruckIcon className="h-5 w-5 text-blue-500" data-id="element-1658" />;
      case 'pending':
        return <AlertCircleIcon className="h-5 w-5 text-orange-500" data-id="element-1659" />;
      case 'cancelled':
        return <XCircleIcon className="h-5 w-5 text-red-500" data-id="element-1660" />;
      case 'refunded':
        return <AlertCircleIcon className="h-5 w-5 text-purple-500" data-id="element-1661" />;
      default:
        return <AlertCircleIcon className="h-5 w-5 text-gray-500" data-id="element-1662" />;
    }
  };
  const getStatusBadgeClass = (status: string) => {
    switch (status.toLowerCase()) {
      case 'completed':
        return 'bg-green-100 text-green-800';
      case 'processing':
        return 'bg-yellow-100 text-yellow-800';
      case 'shipped':
        return 'bg-blue-100 text-blue-800';
      case 'pending':
        return 'bg-orange-100 text-orange-800';
      case 'cancelled':
        return 'bg-red-100 text-red-800';
      case 'refunded':
        return 'bg-purple-100 text-purple-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  return <div className="space-y-6" data-id="element-1663">
      <div className="flex justify-between items-center" data-id="element-1664">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1665">Orders Management</h1>
        <div className="flex space-x-3" data-id="element-1666">
          <button className="bg-white border border-gray-300 text-gray-700 py-2 px-4 rounded-md hover:bg-gray-50 transition-colors flex items-center" data-id="element-1667">
            <DownloadIcon className="h-5 w-5 mr-2" data-id="element-1668" />
            Export
          </button>
        </div>
      </div>
      {/* Filters and Search */}
      <div className="bg-white rounded-lg shadow-sm p-4 border border-gray-200" data-id="element-1669">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4" data-id="element-1670">
          <div className="flex flex-col sm:flex-row gap-3" data-id="element-1671">
            <div className="relative" data-id="element-1672">
              <select className="appearance-none pl-3 pr-10 py-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" value={selectedStatus} onChange={e => setSelectedStatus(e.target.value)} data-id="element-1673">
                <option value="all" data-id="element-1674">All Status</option>
                <option value="pending" data-id="element-1675">Pending</option>
                <option value="processing" data-id="element-1676">Processing</option>
                <option value="shipped" data-id="element-1677">Shipped</option>
                <option value="completed" data-id="element-1678">Completed</option>
                <option value="cancelled" data-id="element-1679">Cancelled</option>
                <option value="refunded" data-id="element-1680">Refunded</option>
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" data-id="element-1681">
                <FilterIcon className="h-4 w-4 text-gray-400" data-id="element-1682" />
              </div>
            </div>
            <div className="relative" data-id="element-1683">
              <select className="appearance-none pl-3 pr-10 py-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1684">
                <option value="" data-id="element-1685">All Dealers</option>
                <option value="TechHub Singapore" data-id="element-1686">TechHub Singapore</option>
                <option value="Mobile Masters" data-id="element-1687">Mobile Masters</option>
                <option value="Gadget World" data-id="element-1688">Gadget World</option>
                <option value="Phone Paradise" data-id="element-1689">Phone Paradise</option>
                <option value="Digital Dreams" data-id="element-1690">Digital Dreams</option>
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" data-id="element-1691">
                <FilterIcon className="h-4 w-4 text-gray-400" data-id="element-1692" />
              </div>
            </div>
            <div className="relative" data-id="element-1693">
              <select className="appearance-none pl-3 pr-10 py-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1694">
                <option value="" data-id="element-1695">Last 30 days</option>
                <option value="" data-id="element-1696">Last 7 days</option>
                <option value="" data-id="element-1697">Today</option>
                <option value="" data-id="element-1698">This month</option>
                <option value="" data-id="element-1699">Last month</option>
                <option value="" data-id="element-1700">Custom range</option>
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" data-id="element-1701">
                <FilterIcon className="h-4 w-4 text-gray-400" data-id="element-1702" />
              </div>
            </div>
          </div>
          <div className="relative w-full md:w-64" data-id="element-1703">
            <input type="text" placeholder="Search orders..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1704" />
            <SearchIcon className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-1705" />
          </div>
        </div>
      </div>
      {/* Orders Table */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-1706">
        <div className="overflow-x-auto" data-id="element-1707">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-1708">
            <thead className="bg-gray-50" data-id="element-1709">
              <tr data-id="element-1710">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1711">
                  Order ID
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1712">
                  Customer
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1713">
                  Dealer
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1714">
                  Date
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1715">
                  Amount
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1716">
                  Status
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1717">
                  Items
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1718">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-1719">
              {filteredOrders.map(order => <tr key={order.id} className="hover:bg-gray-50" data-id="element-1720">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-blue-600" data-id="element-1721">
                    {order.id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-1722">
                    {order.customer}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1723">
                    {order.dealer}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1724">
                    {order.date}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1725">
                    {order.amount}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1726">
                    <div className="flex items-center" data-id="element-1727">
                      {getStatusIcon(order.status)}
                      <span className={`ml-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusBadgeClass(order.status)}`} data-id="element-1728">
                        {order.status}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1729">
                    {order.items} item{order.items > 1 ? 's' : ''}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1730">
                    <button className="text-blue-600 hover:text-blue-900" data-id="element-1731">
                      <EyeIcon className="h-5 w-5" data-id="element-1732" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between" data-id="element-1733">
          <div className="text-sm text-gray-700" data-id="element-1734">
            Showing <span className="font-medium" data-id="element-1735">1</span> to{' '}
            <span className="font-medium" data-id="element-1736">{filteredOrders.length}</span> of{' '}
            <span className="font-medium" data-id="element-1737">{orders.length}</span> results
          </div>
          <div className="flex space-x-2" data-id="element-1738">
            <button className="px-3 py-1 border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-1739">
              Previous
            </button>
            <button className="px-3 py-1 border border-blue-600 rounded-md bg-blue-600 text-white hover:bg-blue-700" data-id="element-1740">
              1
            </button>
            <button className="px-3 py-1 border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50" data-id="element-1741">
              2
            </button>
            <button className="px-3 py-1 border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50" data-id="element-1742">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>;
};